import React, { useEffect, useRef } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import Header from "./Header";
import { MESFMainContainer } from "./MainContainer";

const Navigation = ({
	showAreaSelector = false,
	showTrendingsV2Icon = true,
	navbarTitle = "MESF",
	byPassHeaderRoutes = [],
}: {
	showAreaSelector?: boolean;
	showTrendingsV2Icon?: boolean;
	navbarTitle?: string;
	byPassHeaderRoutes?: string[];
}) => {
	const [params, setParams] = useSearchParams();
	const mounted = useRef(true);

	const location = useLocation();

	useEffect(() => {
		if (params.has("redirectTo")) {
			setTimeout(() => {
				if (mounted.current) {
					window.location.href = decodeURI(params.get("redirectTo")!);
				}
			}, 100);
		}

		return () => {
			mounted.current = false;
		};
	}, [params.toString()]);

	const byPassHeader = byPassHeaderRoutes.some((route) =>
		location.pathname.startsWith(route),
	);

	return (
		<div className="wrapper">
			{/*<!-- top navbar-->*/}
			{!byPassHeader && (
				<Header
					showAreaSelector={showAreaSelector}
					navbarTitle={navbarTitle}
					showTrendingsV2Icon={showTrendingsV2Icon}
				/>
			)}
			{/*<!-- sidebar-->*/}
			{/* <SideBar/>      */}

			<MESFMainContainer />
			{/*<!-- Page footer-->*/}
			{/* <Footer/>                      */}
		</div>
	);
};
export default Navigation;
